import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../setupStore';

export interface TokenState {
  value: string;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: TokenState = {
  value: '',
  status: 'idle',
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.

export const TokenSlice = createSlice({
  name: 'token',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    registerKeycloakToken: (
      state,
      action: PayloadAction<string | undefined>,
    ) => {
      state.value = action.payload || '';
    },
  },
});

export const { registerKeycloakToken } = TokenSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example, `useSelector((state: RootState) => state.counter.value)`
export const selectToken = (state: RootState) => state.token.value;

export default TokenSlice.reducer;
